import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";

const Terms = () => {
  return (
    <>
      <RootLayout>
        <Animation />

        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Terms and Conditions"} />
        <section className="about-two py-60 position-relative z-1">
          <div className="position-relative">
            <div className="container">
              <div className="row gy-4 align-items-center">
                <div className="col-lg-12">
                  <div className="join-community__content">
                    <div className="mb-40">
                      <p
                        className="text-neutral-500 text-line-2"
                        data-aos="fade-up"
                        data-aos-duration="800"
                        data-aos-delay="120"
                      >
                        The utilization of this <b>School</b> website is
                        governed by the policies, terms, and conditions set
                        forth (Terms and Conditions of Use). Please read them
                        through thoroughly and carefully. Your use of this site
                        indicates your acceptance of each of the Terms and
                        Conditions of Use. NATIONAL PUBLIC SCHOOL-KUDLU reserves
                        the right to modify this site in any fashion at any time
                        as well as these Terms and Conditions of use.
                        <br />
                        <br />
                        <h5>Copyright and Trademark</h5>
                        <ul>
                          <li>
                            • This website contains copyrighted material,
                            trademarks and other proprietary information
                            including items such as photography, video,
                            graphics, text, software and forms. Each of the
                            items mentioned prior are subject to copyright laws.
                            You may not modify, publish, display, transmit or
                            subject yourself to the transfer or sale or in any
                            form, exploit the content that exists on this
                            website or that of any affiliates.
                          </li>
                          <li>
                            • The data, information, materials, and services
                            provided on this website are for the use to benefit
                            the students, parents, members, and staff of the
                            NATIONAL PUBLIC SCHOOL-KUDLU and beyond. Changes or
                            modifications to pages, structure or procedure may
                            incur at any time on this website. The materials on
                            this website are provided in an “as is” state,
                            without warranties of any type, either expressed or
                            implied to the largest extent permissible to the
                            applicable law.
                          </li>
                          <li>
                            • You shall not upload, e-mail, post or make
                            available in any other fashion any material on this
                            website that is protected by copyright, trademark or
                            other laws; that is, without direct permission from
                            the absolute source.
                          </li>
                        </ul>
                        <br />
                        <br />
                        <h5>
                          Disclaimer of Warranty / Limitation of Website
                          Liability
                        </h5>
                        <ul>
                          <li>
                            • Agreement: You shall agree that the use of this
                            website is at your sole risk. NATIONAL PUBLIC
                            SCHOOL-KUDLU, affiliates or any other organization
                            or members, therein, shall not incur any
                            responsibility for your use of this website. The
                            School, is not liable for any negative impact that
                            is incurred to any one individual’s computer.
                          </li>
                          <li>
                            • Limited License: NATIONAL PUBLIC SCHOOL-KUDLU
                            website is for educational use. Unless otherwise
                            expressed, you may not modify, copy, distribute,
                            re-distribute, transmit, display, use, publish,
                            license, create derivative material from, transfer,
                            or sell any information or content contained
                            anywhere on this website or any sub-websites, via
                            direct or indirect means.
                          </li>
                          <li>
                            • Limitation of Liability: NATIONAL PUBLIC
                            SCHOOL-KUDLU shall not be liable for any loss or
                            damage, including without limitation direct or
                            indirect, special, economic, incidental or
                            consequential damages, losses or expenses arising in
                            connection with this site or use there of or
                            inability to use by any party, or in connection with
                            any failure of performance, error, omission,
                            interruption, defect, delay in operation or
                            transmission, computer virus or line or system
                            failure, even if School has been advised of the
                            possibility of such damages, losses or expenses.
                          </li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default Terms;
